import { useTranslations } from 'next-intl';
import { ThirdPartSelectors } from '@headless-workspace/config';
import { UIPromoBanner, UIMarketingBanner } from '@headless-workspace/core-ui';
import { InnerHTML } from '@headless-workspace/domain/common/client';
import { isMarketingBanner, isPromoBanner, ProductDetailBannersValue } from '@headless-workspace/domain/common/server';
import { ProductDetailMarketingVideoLibrary } from '../marketingVideoLibrary/';

type ProductDetailBanners = {
    banners?: ProductDetailBannersValue;
};

export const ProductDetailBanners = ({ banners }: ProductDetailBanners) => {
    const t = useTranslations('Discover.Pdp.banner');

    return (
        <div id={ThirdPartSelectors.ProductBanners} className={'flex flex-col gap-0.5'}>
            {banners?.map((banner) => {
                switch (true) {
                    case isPromoBanner(banner):
                        return (
                            <UIPromoBanner
                                key={banner.id}
                                href={banner.href}
                                title={<InnerHTML rawHtml={{ content: banner.title }} />}
                                description={
                                    banner.description ? (
                                        <InnerHTML rawHtml={{ content: banner.description }} />
                                    ) : undefined
                                }
                                image={banner.image}
                                accordion={
                                    banner.content
                                        ? {
                                              title: t('action.fidelityBanner'),
                                              content: <InnerHTML rawHtml={{ content: banner.content }} />,
                                          }
                                        : undefined
                                }
                            />
                        );

                    case isMarketingBanner(banner):
                        return (
                            <UIMarketingBanner
                                key={banner.id}
                                content={{
                                    description: {
                                        text: <InnerHTML rawHtml={{ content: banner.content }} />,
                                    },
                                }}
                                image={{
                                    src: banner.image,
                                }}
                                href={banner.button.href}
                            />
                        );
                    default:
                        return null;
                }
            })}
            <ProductDetailMarketingVideoLibrary />
        </div>
    );
};
